import React from "react";
import _ from "underscore";
import errors from "../../../i18n/en/error.json";
import DisplayMessage from "./DisplayMessage";

const shouldWarningPopUp = (value, submittedValue) => {
  if (submittedValue !== undefined) {
    // After obtaining the response from the Validation API
    return true;
  }

  return false;
};

export const ErrorMessage = ({
  input,
  serverValidation,
  error,
  actions,
  changeTargetUUID,
}) => {
  const submittedValue =
    serverValidation &&
    serverValidation.AssayDesign &&
    serverValidation.AssayDesign.Name;

  return (
    <React.Fragment>
      {serverValidation &&
        !_.isEmpty(serverValidation) &&
        !_.isEmpty(serverValidation.Errors) &&
        input &&
        input.value &&
        !error &&
        shouldWarningPopUp(input.value, submittedValue) && (
          <DisplayMessage
            serverValidation={serverValidation}
            input={input}
            actions={actions}
            changeTargetUUID={changeTargetUUID}
          />
        )}
    </React.Fragment>
  );
};
